<template>
  <ChatModel/>
  <div class="app-container">
    <!-- 根据当前路由判断是否显示导航栏 -->
    <TheHeader v-if="isLoginPage" />
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <TheFooter />
  </div>
</template>

<script setup>
import { provide, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import TheHeader from './components/elements/TheHeader.vue'
import TheFooter from './components/elements/TheFooter.vue'
import ChatModel from './components/elements/ChatModel.vue'
// 提供全局季节状态，可被所有组件访问
const currentSeason = ref('autumn')
provide('currentSeason', currentSeason)

// 获取当前路由信息
const route = useRoute()

// 计算属性，判断当前是否为登录页面
const isLoginPage = computed(() => {
  return route.name !== 'Login'
})
</script>

<style>
/* 全局样式 */
:root {
  --color-brown: #8B4513;
  --color-beige: #F5DEB3;
  --color-red: #C3272B;
  --color-blue: #3B5A9D;
}

body {
  font-family: 'Noto Sans SC', sans-serif;
  color: var(--color-brown);
  margin: 0;
  padding: 0;
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s ease;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}

/* 自定义字体样式 */
.font-title {
  font-family: 'STKaiti', 'SimSun', serif; /* 模拟汉仪尚巍手书 */
  letter-spacing: 0.05em;
}

.font-body {
  font-family: 'Noto Sans SC', 'Source Han Sans CN', sans-serif; /* 思源黑体 */
}

.font-accent {
  font-family: 'Cinzel', serif; /* 古典衬线字体 */
}
#app{
  margin-top: 80px;
}
</style>
    